import { Dropdown } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import MultiSelectOverlay from '../MultiSelectOverlay';
import { DropdownLabel } from '../styled/form/dropdown';
import { RotateIcon } from '../styled/icon';
const ClosedText = styled.span `
  text-align: left;
`;
// Deisgned to work with the options and selected state managed from the parent component through
// the selected and onSelect parameters. For use with an AntD form object, see MultiSelectForm.
export const MultiSelect = ({ closedLabel, displayName, fieldName, onConfirm, onReset, onCancel, onSelect, selected, options, showAll, showSearch, shifted, closeOnReset }) => {
    const [visible, setVisible] = useState(false);
    const confirm = () => {
        if (!!onConfirm) {
            onConfirm();
        }
        setVisible(false);
    };
    const reset = () => {
        if (!!onReset) {
            onReset();
        }
        else {
            onSelect([]);
        }
        if (closeOnReset) {
            setVisible(false);
        }
    };
    const visibilityChanged = () => {
        setVisible(!visible);
        if (visible && !!onCancel) {
            onCancel();
        }
    };
    return (React.createElement(Dropdown, { onVisibleChange: visibilityChanged, overlay: React.createElement(MultiSelectOverlay, { displayName: displayName || closedLabel, onConfirm: confirm, onReset: reset, onSelect: onSelect, options: options, selected: selected, showAll: showAll, showSearch: showSearch, shifted: shifted, visible: visible }), trigger: ['click'], visible: visible },
        React.createElement(DropdownLabel, { onClick: e => e.preventDefault() },
            React.createElement(ClosedText, null, closedLabel),
            React.createElement(RotateIcon, { type: "down", rotate: visible ? 180 : 0 }))));
};
export default MultiSelect;
